




import { Component, Model } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import Input from './input'
import * as ruleNames from './constants/ruleNames'
import Form from '@/mixins/form'

@Component
export default class CheckboxInput extends mixins(Input) {
  @Model('input', { type: [Boolean, Number] }) value!: boolean | number

  get innerValue() {
    return Boolean(this.value)
  }

  set innerValue(newValue: boolean) {
    const cleanNewValue =
      typeof this.value === 'number' ? Number(newValue) : newValue

    if (cleanNewValue !== this.value) {
      this.$v.$touch()
      this.$emit('input', cleanNewValue)

      if (this.notify) {
        ;(this.$parent as Form).validator.handleValidate()
      }
    }
  }

  supportedRules: Array<string> = [ruleNames.REQUIRED_AT_LEAST_N]
}
